import { render, staticRenderFns } from "./VueBootstrap.vue?vue&type=template&id=204399b7"
import script from "./VueBootstrap.vue?vue&type=script&lang=js"
export * from "./VueBootstrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports